import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import RoleAll from './components/RoleAll';

export default function Role() {
  return (
    <>
      <MainContent
        titulo='Administración de Roles'
        component={<RoleAll />}
        tableMaxWidth={true}
      />
      
      <Outlet />
    </>
  );
}